import React, { useState } from 'react';

import { QuickPick } from 'src/components/CustomersBar/EventsTab/RacingTab/QuickPick/QuickPick';
import { observer } from 'src/utils/mobx-react';
import { useAppStateContext } from 'src/AppState/AppState';
import { QuickPickViewState } from 'src/components/CustomersBar/EventsTab/RacingTab/QuickPickView/QuickPickView.state';
import Loading from 'src/components/Loading';
import { FilterTabs } from 'src/components/Filters/FilterTabs';
import { AutoMap } from 'src_common/common/mobx-utils/AutoMap';
import {
    FilterWrapper,
    Header,
} from 'src/components/CustomersBar/EventsTab/RacingTab/QuickPickView/QuickPickView.style';
export type QuickPickSportType = 'horseracing' | 'greyhoundracing' | 'internationalhorseracing';

export interface QuickPickViewPropsType {
    userId: number;
    sport: QuickPickSportType;
}

export const QuickPickView = observer('QuickPickView', (props: QuickPickViewPropsType) => {
    const appState = useAppStateContext();
    const [stateMap] = useState(
        () => new AutoMap<string, QuickPickViewState>((sportId) => new QuickPickViewState(appState, sportId))
    );
    const state = stateMap.get(props.sport);

    // if (state.filteredEventsId === null) {
    //     return null;
    // }
    return (
        <div className='events-tab--horse-racing'>
            <Header>
                <FilterWrapper>
                    <FilterTabs
                        className='filters events-tab--horse-racing__time-filters'
                        available={state.timeFilterState.availableTimeFilters}
                        active={state.timeFilterState.currentTimeFilter}
                        onChange={state.timeFilterState.onSetTimeFilter}
                    />
                </FilterWrapper>
                <FilterTabs
                    className='filters events-tab--horse-racing__competitions-filters'
                    available={state.competitionFilterState.allCompetitionForFilters}
                    active={state.competitionFilterState.selectedCompetitionIdFromURL}
                    onChange={state.competitionFilterState.setSelectedCompetitionIdToURL}
                />
                {state.competitionFilterState.selectedEventIdFromURL === null ? null : (
                    <FilterTabs
                        className='filters events-tab--horse-racing__markets-filters'
                        available={state.marketFilterState.availableMarketsNameForSelectedEvent}
                        active={state.marketFilterState.getMarketType}
                        onChange={state.marketFilterState.setMarket}
                    />
                )}
            </Header>
            <QuickPick
                userId={props.userId}
                quickPickState={state}
            />
            <Loading
                message='Loading...'
                active={state.isLoading}
            />
        </div>
    );
});
